/* eslint-disable max-len */
import React from "react";

/**
 * A functional React component that renders a Radio SVG icon UI element.
 */
export const IconLeftArrow: React.FC = () => (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.08951 2.38236L6.6753 0.968146L1.01845 6.625L6.6753 12.2819L8.08951 10.8676L3.84687 6.625L8.08951 2.38236Z" fill="#666666" />
    </svg>
);
